import axios from "api/axios"
import {
  APIResponse,
  Config,
  ConfigWithURLParams,
  NoContentType,
  PaginatedAPIResponse,
} from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import { Masterclass, RegisterResponse } from "./types"
import { urls } from "./urls"

export default {
  list: async ({
    params,
  }: Config): Promise<PaginatedAPIResponse<Masterclass[]>> => {
    try {
      const res = await axios.get(urls.list(), { params })
      return formatSuccessResponse(res, { paginatedResponse: true })
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  overview: async (): Promise<
    APIResponse<{ upcomingMasterclass: Masterclass | null }>
  > => {
    try {
      const res = await axios.get(urls.overview())
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  getItoMasterclass: async ({
    urlParams: { slug },
  }: ConfigWithURLParams): Promise<APIResponse<Masterclass>> => {
    try {
      const res = await axios.get(urls.masterclass(slug))
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  trackItoMasterclass: async ({
    urlParams: { videoMeetingId },
    data,
  }: ConfigWithURLParams): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.post(urls.trackMasterclass(videoMeetingId), data)
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
  registration: {
    create: async ({
      data,
      urlParams: { masterclassSlug },
    }: ConfigWithURLParams): Promise<APIResponse<RegisterResponse>> => {
      try {
        const res = await axios.post(urls.register(masterclassSlug), data)
        return formatSuccessResponse(res)
      } catch (e) {
        throw formatErrorResponse(e)
      }
    },
  },
  watchFreeMasterclass: async ({
    urlParams: { masterclassSlug },
  }: ConfigWithURLParams): Promise<APIResponse<any>> => {
    try {
      const res = await axios.get(urls.watchFreeMasterclass(masterclassSlug))
      return formatSuccessResponse(res)
    } catch (e) {
      return formatErrorResponse(e)
    }
  },
}
